import './header.css'
import logo from '../assets/logoGood.png';
import { Link } from 'react-router-dom';

export default function Header() {
    return (
        <header className="App-header">
            <div className='headerImgWrapper'>
                <Link to="/" className="logoLink" aria-label="Home">
                    <img src={logo} alt='Orbis logo' />
                </Link>
            </div>

            <Link to="/journey" className="journeyButton" aria-label="Our Journey">Our Journey</Link>

        </header>
    )
}